import React, { useEffect } from 'react'
import './DeleteModal.css'
import ReactDOM  from 'react-dom'


export default function DeleteModal({showModal,deleteApiHandler}) {

useEffect(()=>{
    const checkKey=(e)=>{
if(e.keyCode===27){
    showModal()
} }
window.addEventListener('keydown',checkKey)
return()=>window.removeEventListener('keydown',checkKey)
})

  return ReactDOM.createPortal(
    <div className='delemodal-container2'>.
    
    <div className='delemodal2-div2' >
 <h1>آیا از حذف اطمینان دارید؟</h1>
<div>
    <button className='delmodal2-button ok' onClick={deleteApiHandler}>بله</button>
 <button className='delmodal2-button no' onClick={showModal}>خیر</button> 
</div>

    </div>
   
    </div>


    ,document.getElementById('modals-parent') 

  )
}
